module.exports = {
  segmentAnalytics: {
    trackEvent: () => {}
  }
}
